export default __webpack_public_path__ + "static/media/asteroid.c4bc9e2a.png";